var _linearGradient, _linearGradient2, _linearGradient3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 65.564,
    y2: 6.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006df0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 47.38,
    x2: 47.38,
    xlinkHref: "#New_Gradient_Swatch_3",
    y1: 65.564,
    y2: 6.139
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 16.62,
    x2: 16.62,
    xlinkHref: "#New_Gradient_Swatch_3",
    y1: 65.564,
    y2: 6.139
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "healthcare-covid19-coronavirus-hand-hearth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38 13h-3v-3a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v3h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-3a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -1-1h-3v-2h3a1 1 0 0 0 1-1v-3h2v3a1 1 0 0 0 1 1h3z",
    fill: "url(#New_Gradient_Swatch_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.73 18.36a4.578 4.578 0 0 0 .03-.53 4.02 4.02 0 0 0 -3.18-3.91 4.071 4.071 0 0 0 -4.7 2.97l-4.4 12.66a1.632 1.632 0 0 0 -.19.09l-8.84 5.18a9.017 9.017 0 0 0 -4.45 7.76v9.42a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0 -1-1v-2.2a3.039 3.039 0 0 1 1-2.24l6.76-6.01a4.931 4.931 0 0 0 1.52-2.45l4.34-16.23a3.955 3.955 0 0 0 .14-1.04 4.019 4.019 0 0 0 -2.03-3.47zm-5.94-.88a2.113 2.113 0 0 1 2.38-1.6 2 2 0 0 1 1.59 1.95v.02a4.1 4.1 0 0 0 -3.89 3.06l-2.79 8.61a4.2 4.2 0 0 0 -1.34-.38zm-6.79 42.52h-12v-6h12zm12.69-37.65-4.35 16.24a2.981 2.981 0 0 1 -.9 1.46l-6.77 6.01a5.056 5.056 0 0 0 -1.67 3.74v2.2h-10v-9.42a7.052 7.052 0 0 1 3.46-6.04l8.83-5.17a2 2 0 0 1 2.74.73 2.06 2.06 0 0 1 .2 1.52 2 2 0 0 1 -.94 1.21l-5.73 3.31a1 1 0 0 0 1 1.73l5.73-3.31a3.948 3.948 0 0 0 1.87-2.43 4.007 4.007 0 0 0 -.4-3.03l-.06-.09 3.09-9.53a2.113 2.113 0 0 1 2.38-1.6 2 2 0 0 1 1.59 1.95 1.722 1.722 0 0 1 -.07.52z",
    fill: "url(#New_Gradient_Swatch_3-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 52v-9.42a9.017 9.017 0 0 0 -4.45-7.76l-8.84-5.19c-.06-.03-.13-.05-.19-.08l-4.37-12.59a4.107 4.107 0 0 0 -4.73-3.04 4.02 4.02 0 0 0 -3.18 3.91 4.578 4.578 0 0 0 .03.53 4.019 4.019 0 0 0 -2.03 3.47 4.421 4.421 0 0 0 .13 1.04l4.35 16.22a4.916 4.916 0 0 0 1.52 2.46l6.75 6.01a3.012 3.012 0 0 1 1.01 2.24v2.2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0 -1-1zm-23.76-34.17a2 2 0 0 1 1.58-1.95 2.161 2.161 0 0 1 2.42 1.67l4.02 11.59a4.2 4.2 0 0 0 -1.34.38l-2.77-8.56a4.149 4.149 0 0 0 -3.91-3.11zm10.08 28.23-6.76-6.01a2.965 2.965 0 0 1 -.9-1.47l-4.36-16.23a2.121 2.121 0 0 1 -.06-.52 2 2 0 0 1 1.58-1.95 2.144 2.144 0 0 1 2.41 1.65l3.07 9.48-.06.09a4.007 4.007 0 0 0 -.4 3.03 3.948 3.948 0 0 0 1.87 2.43l5.73 3.31a1 1 0 0 0 1-1.73l-5.73-3.31a2 2 0 0 1 -.94-1.21 2.06 2.06 0 0 1 .2-1.52 2 2 0 0 1 2.73-.74l8.84 5.18a7.052 7.052 0 0 1 3.46 6.04v9.42h-10v-2.2a5.03 5.03 0 0 0 -1.68-3.74zm12.68 13.94h-12v-6h12z",
    fill: "url(#New_Gradient_Swatch_3-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.147 5.132a9.994 9.994 0 0 0 -14.147.001 9.992 9.992 0 0 0 -14.146 0 10.005 10.005 0 0 0 0 14.134l13.44 13.44a1 1 0 0 0 1.414 0l13.44-13.44a10.006 10.006 0 0 0 -.001-14.135zm-14.147 25.454-12.733-12.733a8 8 0 0 1 5.663-13.653 7.916 7.916 0 0 1 5.653 2.347l.71.71a1 1 0 0 0 1.414 0l.712-.712a7.993 7.993 0 0 1 11.314 0 8 8 0 0 1 0 11.306z",
    fill: "url(#New_Gradient_Swatch_3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.30b4dd5a0458a8c2d52a0798acefc8dd.svg";
export { ForwardRef as ReactComponent };